export default "__VITE_ASSET__70Xmhb_R__"